import React, { Component } from "react";
import { MessageSourceProps, withMessages } from "react-message-source";
import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import { Divider } from 'semantic-ui-react';
import PraxStyledSegment from 'components/layout/PraxStyledSegment';
import styled from 'styled-components';
import { RouterProps } from 'react-router';
import AutomaticBillingOptionsSegment from 'components/automatic-billiing/segments/AutomaticBillingOptionsSegment';
import AutomaticBillingTablesSegment from 'components/automatic-billiing/segments/AutomaticBillingTablesSegment';
import {
  AutomaticBillingSearchResponse,
  AutomaticBillingSearchResponseWrapper,
  AutomaticBillRunSearchData,
  TariffDto
} from 'ts-types/api.types';
import { getAllTariffs } from 'services/tariffServices';
import { noop } from 'utils/functionUtils';
import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import FullScreenPageHeader from 'components/FullScreenPageHeader';
import StyledErrorMessage from 'components/layout/StyledErrorMessage';

const StyledPraxSegment = styled(PraxStyledSegment)`
  padding: 0 !important;
  margin: 0 !important;
`;

const ContentDiv = styled.div`
  flex: 1 1 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

interface Props extends AuthConsumerRenderProps, MessageSourceProps, RouterProps {
}

interface State {
  treatments: Array<AutomaticBillingSearchResponse>,
  treatmentDataId?: string,
  treatmentsLoading: boolean,
  tariffs: Array<TariffDto>,
  errorMessage?: string,
  automaticBillRunSearchData?: AutomaticBillRunSearchData
  cancelTokenSource: CancelTokenSource
}

class AutomaticBillingView extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const cancelTokenSource = axios.CancelToken.source();
    const {getMessage} = this.props;

    this.state = {
      treatments: [],
      treatmentsLoading: false,
      tariffs: [],
      cancelTokenSource: cancelTokenSource
    };

    getAllTariffs(cancelTokenSource).then(response => {
          this.setState({
            tariffs: response
          })
        })
        .catch(() => {
          this.setErrorMessage(getMessage("error.general"));
        })
        .finally(noop);
  }

  setErrorMessage = (errorMessage?: string) => {
    this.setState({
      errorMessage: errorMessage
    });
  };

  setAutomaticBillRunSearchData = (searchData: AutomaticBillRunSearchData) => {
    this.setState({
      automaticBillRunSearchData: searchData
    })
  };

  goToHome = () => {
    const {history} = this.props;

    history.push("/");
  };

  goToRunData = () => {
    const {history} = this.props;

    history.push("/automatic-billing/run-data");
  }

  onFilterTreatments = (searchResponseWrapper: AutomaticBillingSearchResponseWrapper) => {
    this.setState({
      treatments: searchResponseWrapper.treatments,
      treatmentDataId: searchResponseWrapper.treatmentDataId
    })
  };

  onTreatmentsLoadingChange = (treatmentsLoading: boolean) => {
    this.setState({
      treatmentsLoading: treatmentsLoading
    })
  };

  render(): React.ReactElement {

    const {getMessage} = this.props;

    const {
      treatments,
      treatmentsLoading,
      tariffs,
      treatmentDataId,
      automaticBillRunSearchData,
      errorMessage
    } = this.state;

    return (
        <ContentDiv>
          <FullScreenPageHeader headerMessage={getMessage("header.navigation.automaticBilling")}
                                buttonMessage={getMessage("back")}
                                rightButtonMessage={getMessage("automaticBilling.automaticBillingHistory")}
                                onConfirm={() => this.goToHome()}
                                onRightButtonClick={() => this.goToRunData()}/>

          <StyledPraxSegment>
            {errorMessage
            && (
                <StyledErrorMessage onDismiss={() => this.setErrorMessage()} style={{margin: 0}}>
                  {errorMessage}
                </StyledErrorMessage>
            )
            }
            <AutomaticBillingOptionsSegment
                onFilterTreatments={this.onFilterTreatments}
                onTreatmentsLoadingChange={this.onTreatmentsLoadingChange}
                tariffs={tariffs}
                setAutomaticBillRunSearchData={this.setAutomaticBillRunSearchData}
                setErrorMessage={this.setErrorMessage}
            />
            <Divider/>
            <AutomaticBillingTablesSegment
                treatments={treatments}
                treatmentsLoading={treatmentsLoading}
                tariffs={tariffs}
                treatmentDataId={treatmentDataId}
                automaticBillRunSearchData={automaticBillRunSearchData}
                setErrorMessage={this.setErrorMessage}
            />
          </StyledPraxSegment>
        </ContentDiv>
    );
  }

}

export default withAuthContext(withMessages(AutomaticBillingView));
